import $ from "jquery";


let render = true;
runForm();
render = false;
if ($('.gform_wrapper').length) {
    jQuery(document).bind('gform_post_render', function () { // eslint-disable-line
        runForm();
    });
}

function runForm() {
    const el = $('.ginput_container_text, .ginput_container_email, .ginput_container_phone, .ginput_container_textarea, .ginput_container_number');
    const check = $('.ginput_container_consent, .ginput_container_checkbox');
    const upload = $('.ginput_container_fileupload');

    check.addClass('form-check');
    check.find('label').addClass('form-check__text');

    if (render) {
        check.find('label').before('<span class="form-check__indicator"></span>');
    }

    const phone = $('.ginput_container_phone input');
    if (phone) {
        phone.each(function () {
            $(this).attr("data-hj-allow", "");
        });
    }

    el.parent().addClass('gfield_effect');
    $('.ginput_container_select').parent().addClass('gfield_effect_select');

    el.each(function () {
        $(this).children('input, textarea').focus(function () {
            $(this).parent().siblings('.gfield_label').addClass('is-active');
        }).focusout(function () {
            if ($(this).val() === '') {
                $(this).parent().siblings('.gfield_label').removeClass('is-active');
            } else {
                $(this).parent().siblings('.gfield_label').addClass('is-active');
            }
        });
    });

    upload.each(function () {
        let labelValue = $(this).parent().find('.gfield_label').text();
        $(this).find('.gform_fileupload_rules').text(labelValue);
    });

    $('.ginput_container_text input, .ginput_container_email input, .ginput_container_phone input, .ginput_container_textarea textarea').each(function () {
        if ($(this).val()) {
            $(this).parent().siblings('.gfield_label').addClass('is-active');
        }
    });
    render = true;
}
